import { LoadableAfterPaint } from '@confluence/loadable';

import { EllipsisPlaceholder } from '../src/EllipsisPlaceholder';

export const LivePagesEllipsisDropdownComponent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LivePagesEllipsisDropdown" */ '../src/LivePagesEllipsisDropdown'
			)
		).LivePagesEllipsisDropdownComponent,
	loading: EllipsisPlaceholder,
});
